module.exports = __webpack_public_path__ + "img/Kemiske-Blandinger-og-Gifte.81a3d86e.jpg";